var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.pdp = {
    VAR: {},
    init: function () {
        var _this = this;
        // This can be ajax loaded content, so use event delegation for dynamically added forms
        document.body.addEventListener('submit', function (e) {
            var form = e.target;
            if (
                form.matches &&
                form.matches('form[action="/cart/add"].fs-product-form')
            ) {
                e.preventDefault();
                var addToCartBtn = form.querySelector('.addtocart');
                if (addToCartBtn) {
                    addToCartBtn.classList.add('disabled');
                    addToCartBtn.disabled = true;
                }

                var formData = new FormData(form);

                fetch('/cart/add.js', {
                    method: 'POST',
                    body: new URLSearchParams(formData),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        if (typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
                            PROJ.ajaxcart.updateCart();
                        }
                        if (addToCartBtn) {
                            addToCartBtn.classList.remove('disabled');
                            addToCartBtn.disabled = false;
                        }
                    })
                    .catch(error => {
                        if (typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
                            PROJ.ajaxcart.updateCart();
                        }
                        console.error('Error adding item to cart:', error);
                    });
            }
        });

        // Handle option swatch/item clicks for custom product form

        ['click', 'touchstart'].forEach(eventType => {
            document.body.addEventListener(eventType, function (e) {

                let target = e.target;

                // for product option clicks
                if (target.closest('[data-o-value]')) {
                    e.preventDefault();
                    let clicked = target.closest('[data-o-value]');

                    var clickedValue = clicked.getAttribute('data-o-value');
                    var parentOption = clicked.closest('[data-oselected-value]');
                    if (!parentOption) return;

                    // Update parent [data-oselected-value] attribute
                    parentOption.setAttribute('data-oselected-value', clickedValue);

                    // Remove 'active' from siblings, add to clicked
                    var siblings = clicked.parentElement.querySelectorAll('[data-o-value]');
                    siblings.forEach(function (sibling) {
                        sibling.classList.remove('active');
                    });
                    clicked.classList.add('active');

                    // Update .zop-title > span text under this option using title attribute
                    var zopTitle = parentOption.querySelector('.zop-title');
                    if (zopTitle) {
                        var span = zopTitle.querySelector('span');
                        if (span) {
                            // Replace text with clicked item's title attribute
                            var newTitle = clicked.getAttribute('title') || '';
                            span.textContent = newTitle;
                        }
                    }

                    // Call updateForm at the end
                    if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.updateForm === 'function') {
                        PROJ.pdp.updateForm(parentOption.closest('form'));
                    }

                    // Scroll to matching data-thumb-var element in thumbnail gallery and update main gallery
                    // Find the product form's section to scope the search
                    var productForm = parentOption.closest('form');
                    var productSection = productForm ? productForm.closest('[id^="shopify-section-"]') : null;
                    var searchScope = productSection || document;

                    var matchingThumb = searchScope.querySelector('[data-thumb-var="' + clickedValue + '"]');
                    if (matchingThumb) {
                        var thumbGallery = matchingThumb.closest('.fs-thumb-gal');
                        if (thumbGallery) {
                            // Get all thumbnail cells
                            var thumbCells = thumbGallery.querySelectorAll('.fs-thu');
                            var thumbIndex = Array.from(thumbCells).indexOf(matchingThumb);

                            if (thumbIndex !== -1 && typeof Flickity !== 'undefined') {
                                // Get Flickity instance for thumbnail gallery
                                var flkty = Flickity.data(thumbGallery);
                                if (flkty) {
                                    flkty.select(thumbIndex);

                                    // Also select the corresponding cell in main gallery
                                    var mainGallery = searchScope.querySelector('.fs-main-gal');
                                    if (mainGallery) {
                                        var mainFlickity = Flickity.data(mainGallery);
                                        if (mainFlickity) {
                                            mainFlickity.select(thumbIndex);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });

        // Sync main gallery on initial load (e.g. direct `?variant=...` URLs)
        // Active swatch state is rendered by Liquid, but the gallery needs JS to reflect it.
        _this.syncGalleryFromActiveOptions();
    },
    syncGalleryFromActiveOptions: function () {
        // Retry briefly because the gallery Flickity instances are created by another script
        // (inside `zpro-product-gallery.liquid`) on `DOMContentLoaded`.
        var maxAttempts = 12;
        var attempt = 0;

        function doSync() {
            attempt++;
            var synced = false;

            var forms = document.querySelectorAll('form.fs-product-form');
            forms.forEach(function (form) {
                var productSection = form.closest('[id^="shopify-section-"]');
                var searchScope = productSection || document;

                var optionComps = form.querySelectorAll('.z-product-option[data-oselected-value]');
                optionComps.forEach(function (optComp) {
                    // Only color swatches map to gallery thumbs (`data-thumb-var`).
                    if (!optComp.querySelector('.z-swatch-set .zwatch-item[data-o-value]')) return;

                    var selectedValue = optComp.getAttribute('data-oselected-value');
                    if (!selectedValue) return;

                    var matchingThumb = searchScope.querySelector('[data-thumb-var="' + selectedValue + '"]');
                    if (!matchingThumb) return;

                    var thumbGallery = matchingThumb.closest('.fs-thumb-gal');
                    if (!thumbGallery || typeof Flickity === 'undefined') return;

                    var thumbCells = thumbGallery.querySelectorAll('.fs-thu');
                    var thumbIndex = Array.from(thumbCells).indexOf(matchingThumb);
                    if (thumbIndex === -1) return;

                    var flkty = Flickity.data(thumbGallery);
                    var mainGallery = searchScope.querySelector('.fs-main-gal');
                    var mainFlickity = mainGallery ? Flickity.data(mainGallery) : null;

                    // Only sync once Flickity is initialized.
                    if (flkty && mainFlickity) {
                        flkty.select(thumbIndex);
                        mainFlickity.select(thumbIndex);
                        synced = true;
                    }
                });
            });

            if (!synced && attempt < maxAttempts) {
                setTimeout(doSync, 100);
            }
        }

        doSync();
    },
    updateForm: function (thisform) {
        // INSERT_YOUR_CODE
        if (!thisform) return;

        // Get all elements with data-oselected-value inside the form
        var selectedOptionEls = thisform.querySelectorAll('[data-oselected-value]');
        var combinedValue = '';
        selectedOptionEls.forEach(function (el) {
            var val = el && el.getAttribute && el.getAttribute('data-oselected-value');
            if (val) {
                combinedValue += val;
            }
        });

        // Find the .pr-variants select box inside the form
        var selectBox = thisform.querySelector('.pr-variants');
        var addToCartBtn = thisform.querySelector('.addtocart');
        if (selectBox) {
            // Find the option whose data-options matches the combined value

            var matchedOption = selectBox.querySelector('option[data-options="' + combinedValue + '"]');
            if (matchedOption) {
                selectBox.value = matchedOption.value;
                // Optionally, trigger change event if needed
                var event = new Event('change', {bubbles: true});
                selectBox.dispatchEvent(event);

                // Get the product URL (without query string or hash)
                var productUrl = window.location.origin + window.location.pathname;
                // Set the URL to productUrl?variant=matchedOption.value
                var newUrl = productUrl + '?variant=' + matchedOption.value;
                window.history.replaceState({}, '', newUrl);

                // Check data-available attribute and update .addtocart button
                if (addToCartBtn) {
                    var isAvailable = matchedOption.getAttribute('data-available');
                    if (isAvailable === 'false') {
                        addToCartBtn.classList.add('deactive');
                        addToCartBtn.setAttribute('disabled', 'disabled');
                    } else {
                        addToCartBtn.classList.remove('deactive');
                        addToCartBtn.removeAttribute('disabled');
                    }

                    // Always use FSPDP for `.pr` so amounts match bundle math and show currency (never raw data-var-price `money` only).
                    if (typeof window.FSPDP !== 'undefined') {
                        if (thisform.querySelector('.jspg-qty') && typeof window.FSPDP.refreshPackPricing === 'function') {
                            window.FSPDP.refreshPackPricing(thisform);
                            setTimeout(function() { window.FSPDP.refreshPackPricing(thisform); }, 0);
                            setTimeout(function() { window.FSPDP.refreshPackPricing(thisform); }, 180);
                        } else if (typeof window.FSPDP.updateAddToCartPriceWithQuantity === 'function') {
                            window.FSPDP.updateAddToCartPriceWithQuantity(thisform);
                            setTimeout(function() { window.FSPDP.updateAddToCartPriceWithQuantity(thisform); }, 0);
                            setTimeout(function() { window.FSPDP.updateAddToCartPriceWithQuantity(thisform); }, 180);
                        }
                    }
                }
            } else {
                // If no matching option, disable add to cart
                if (addToCartBtn) {
                    addToCartBtn.classList.add('deactive');
                    addToCartBtn.setAttribute('disabled', 'disabled');
                }
            }
        } else {
            // If selectBox is not found, disable add to cart
            if (addToCartBtn) {
                addToCartBtn.classList.add('deactive');
                addToCartBtn.setAttribute('disabled', 'disabled');
            }
        }

    },
    updateCart: function () {
        location.reload();
    }
};

document.addEventListener('DOMContentLoaded', function () {
    PROJ.pdp.init();
    // PROJ.ajaxcart.init();

    // fetch(location.pathname+'?section_id=zpro-product-quotes-all')
    //     .then(r=>r.text())
    //     .then(h=>{
    //         let d=document.createElement('div');
    //         d.innerHTML=h;
    //         document.body.appendChild(d.firstElementChild);
    //     });

    // loadProductSection('white-1-4-fold-cocktail-100-organic-cotton-8-x-8-folded-4-x-4-30-units');

});

//quote section load
function loadProductSection(productHandle) {
    document.querySelector('body').classList.add('fs-popup');
    document.querySelector('html').classList.add('fs-popup');

    fetch(`/products/${productHandle}?section_id=zpro-product-quotes-all`)
        .then(r=>r.text())
        .then(h=>{
            let d=document.createElement('div');
            d.innerHTML=h;
            document.body.appendChild(d.firstElementChild);

        // INSERT_YOUR_CODE
        setTimeout(function() {
            var fixpopQuotes = document.querySelector('.fixpop-quotes');
            if (fixpopQuotes) {
                fixpopQuotes.classList.add('active');
            }
        }, 1000);

        });

}

/**
 * Product card (zpro-card-add): tier totals on .jsp-pitem and .jspc-atb-pr when pack tier / variant changes.
 * Cents + Math.ceil match Liquid: variant.price | times: (100-discount) | times: 1.0 | divided_by: 100 | ceil, then * qty.
 */
function fsFormatCardMoneyCents(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) {
        n = 0;
    }
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(n);
    }
    return '$' + (n / 100).toFixed(2);
}

function fsGetCardCurrencyIso(wrap) {
    var raw = null;
    if (wrap && wrap.getAttribute) {
        raw = wrap.getAttribute('data-fs-card-currency-iso');
    }
    if (!raw || typeof raw !== 'string') {
        return null;
    }
    var iso = String(raw).trim().toUpperCase();
    if (!/^[A-Z]{3}$/.test(iso)) {
        return null;
    }
    return iso;
}

function fsGetCardCurrencySymbol(wrap) {
    if (wrap && wrap.getAttribute) {
        var sym = wrap.getAttribute('data-fs-card-currency-symbol');
        if (sym && typeof sym === 'string') {
            return sym;
        }
    }
    return '';
}

function fsGetCardAtcMoneyFormat(wrap) {
    if (wrap && wrap.getAttribute) {
        var fmt = wrap.getAttribute('data-atc-money-with-currency-format');
        if (fmt && String(fmt).length) {
            return fmt;
        }
    }
    return null;
}

/**
 * Card ATC money: Intl when possible, then Shopify.formatMoney with money_with_currency_format,
 * then a symbol + amount + ISO fallback — same approach as PDP `.pr` so currency is always shown.
 */
function fsFormatCardMoneyCentsWithCurrency(cents, wrap) {
    var c = parseInt(cents, 10);
    if (isNaN(c) || c < 0) {
        c = 0;
    }
    var iso = fsGetCardCurrencyIso(wrap);
    var sym = fsGetCardCurrencySymbol(wrap);
    var amt = (c / 100).toFixed(2);
    var out = '';

    if (iso && typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function') {
        try {
            out = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: iso
            }).format(c / 100);
        } catch (eIntl) {
            out = '';
        }
    }

    if (!out) {
        var fmt = fsGetCardAtcMoneyFormat(wrap);
        if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
            if (fmt && String(fmt).length) {
                out = window.Shopify.formatMoney(c, fmt);
            } else {
                out = window.Shopify.formatMoney(c);
            }
        }
    }

    if (!out) {
        if (sym && iso) {
            out = sym + amt + ' ' + iso;
        } else if (iso) {
            out = amt + ' ' + iso;
        } else if (sym) {
            out = sym + amt;
        } else {
            out = '$' + amt;
        }
    }

    if (iso && out && String(out).toUpperCase().indexOf(iso) === -1) {
        out = String(out).trim() + ' ' + iso;
    }
    return out;
}

function fsJspcCardTierQty(wrap) {
    if (!wrap || typeof wrap.querySelector !== 'function') {
        return 1;
    }
    var active = wrap.querySelector('.jsp-add[data-jsp-count].active');
    if (active) {
        var q = parseInt(active.getAttribute('data-jsp-count'), 10);
        if (!isNaN(q) && q >= 1) {
            return q;
        }
    }
    var addBtn = wrap.querySelector('.jspc-add-style[data-directqty]');
    if (addBtn) {
        var dq = parseInt(addBtn.getAttribute('data-directqty'), 10);
        if (!isNaN(dq) && dq >= 1) {
            return dq;
        }
    }
    return 1;
}

function fsJspcCardEffectiveDiscountPct(wrap) {
    if (!wrap || typeof wrap.querySelector !== 'function') {
        return '0';
    }
    var activeTier = wrap.querySelector('.jsp-add[data-jsp-count].active');
    if (activeTier) {
        var td = activeTier.getAttribute('data-tier-discount');
        if (td !== null && td !== '') {
            return td;
        }
    }
    var dd = wrap.getAttribute('data-default-tier-discount');
    if (dd !== null && dd !== '') {
        return dd;
    }
    return '0';
}

function fsJspcCardActiveVariantId(wrap) {
    if (!wrap || typeof wrap.querySelector !== 'function') {
        return null;
    }
    var thumb = wrap.querySelector('.v-thumbnails .v-thumb.active[data-variant-id]');
    if (thumb) {
        return thumb.getAttribute('data-variant-id');
    }
    var addStyle = wrap.querySelector('.jspc-add-style[data-directadd]');
    if (addStyle) {
        return addStyle.getAttribute('data-directadd');
    }
    return null;
}

function fsUpdateJspcCardAddButtonPrice(wrap, discountPct) {
    if (!wrap || typeof wrap.querySelector !== 'function') {
        return;
    }
    var prEl = wrap.querySelector('.jspc-atb-pr');
    if (!prEl) {
        return;
    }
    var d = parseInt(discountPct, 10);
    if (isNaN(d) || d < 0) {
        d = 0;
    }
    if (d > 100) {
        d = 100;
    }
    var qty = fsJspcCardTierQty(wrap);
    var vid = fsJspcCardActiveVariantId(wrap);
    var row = null;
    if (vid) {
        row = wrap.querySelector('.jsp-pitem[data-variant-id="' + vid + '"]');
    }
    if (!row) {
        row = wrap.querySelector('.jsp-pitem[data-variant-price]');
    }
    if (!row) {
        return;
    }
    var base = parseInt(row.getAttribute('data-variant-price'), 10);
    var compareAt = parseInt(row.getAttribute('data-variant-compare'), 10);
    if (isNaN(base)) {
        base = 0;
    }
    if (isNaN(compareAt)) {
        compareAt = 0;
    }
    var showPrice = base;
    if (d > 0) {
        showPrice = Math.ceil((base * (100 - d)) / 100);
    }
    var totalShow = showPrice * qty;
    var tierCompareTotal = base * qty;
    var html = '| ' + fsFormatCardMoneyCentsWithCurrency(totalShow, wrap);
    if (totalShow < tierCompareTotal) {
        html += ' <s>' + fsFormatCardMoneyCents(tierCompareTotal) + '</s>';
    } else if (compareAt > base) {
        html += ' <s>' + fsFormatCardMoneyCents(compareAt * qty) + '</s>';
    }
    prEl.innerHTML = html;
}

function fsUpdateJspcCardPricesForBunDiscount(wrap, discountPct) {
    if (!wrap || typeof wrap.querySelectorAll !== 'function') {
        return;
    }
    var rows = wrap.querySelectorAll('.jsp-pitem[data-variant-price]');
    if (!rows || !rows.length) {
        return;
    }
    var dRaw = discountPct;
    if (dRaw === undefined || dRaw === null || dRaw === '') {
        dRaw = fsJspcCardEffectiveDiscountPct(wrap);
    }
    var d = parseInt(dRaw, 10);
    if (isNaN(d) || d < 0) {
        d = 0;
    }
    if (d > 100) {
        d = 100;
    }
    var qty = fsJspcCardTierQty(wrap);
    rows.forEach(function (row) {
        var base = parseInt(row.getAttribute('data-variant-price'), 10);
        var compareAt = parseInt(row.getAttribute('data-variant-compare'), 10);
        if (isNaN(base)) {
            base = 0;
        }
        if (isNaN(compareAt)) {
            compareAt = 0;
        }
        var showPrice = base;
        if (d > 0) {
            showPrice = Math.ceil((base * (100 - d)) / 100);
        }
        var totalShow = showPrice * qty;
        var tierCompareTotal = base * qty;
        var parts = [];
        if (totalShow < tierCompareTotal) {
            parts.push('<s>' + fsFormatCardMoneyCents(tierCompareTotal) + '</s>&#32;');
        } else if (compareAt > base) {
            parts.push('<s>' + fsFormatCardMoneyCents(compareAt * qty) + '</s>&#32;');
        }
        parts.push('<span>' + fsFormatCardMoneyCents(totalShow) + '</span>');
        var cell = row.querySelector('div');
        if (cell) {
            cell.innerHTML = parts.join('');
        }
    });
    fsUpdateJspcCardAddButtonPrice(wrap, d);
}


document.addEventListener('click', function (e) {
    let target = e.target;

    if (target.closest('.clossquotes')) {
        e.preventDefault();
        document.querySelector('body').classList.remove('fs-popup');
        document.querySelector('html').classList.remove('fs-popup');
        var fixpopQuotesClose = document.querySelector('.fixpop-quotes');
        if (fixpopQuotesClose) {
            fixpopQuotesClose.classList.remove('active');
        }
        return;
    }

    var quoteTrigger = target.closest('[data-quotes]');
    if (quoteTrigger) {
        var chtml = document.querySelector('.fixpop-quotes .content-pop');
        if (!chtml) {
            return;
        }

        e.preventDefault();

        document.querySelector('body').classList.add('fs-popup');
        document.querySelector('html').classList.add('fs-popup');

        var productHandle = quoteTrigger.getAttribute('data-quotes');

        if (productHandle && productHandle.trim() !== "") {
            chtml.innerHTML = productHandle;
        }
    }

    //Product Card
    //product card change bundle products
    if (target.closest('.jsp-add')) {
        var clicked =  target.closest('.jsp-add');
        e.preventDefault();

        // Pack quantity tiers (same product, multiple qty quick add) — see zpro-card-add.liquid / zpro-product-form-new.liquid
        if (clicked.getAttribute('data-jsp-count')) {
            var qtyWrap = clicked.closest('.jspc-add-wrap');
            if (qtyWrap) {
                var qtyTiers = qtyWrap.querySelectorAll('.jsp-add[data-jsp-count]');
                qtyTiers.forEach(function (el) {
                    el.classList.remove('active');
                });
                clicked.classList.add('active');
                var addBtn = qtyWrap.querySelector('.jspc-add-style');
                if (addBtn) {
                    addBtn.setAttribute('data-directqty', clicked.getAttribute('data-jsp-count'));
                }
                var tierDisc = clicked.getAttribute('data-tier-discount');
                if (tierDisc === null || tierDisc === '') {
                    tierDisc = '0';
                }
                fsUpdateJspcCardPricesForBunDiscount(qtyWrap, tierDisc);
            }
            return;
        }

        // Get the parent .sp-product-form-container of the clicked element in the current DOM
        var currentFormContainer = clicked.closest('.jspc-add-wrap');
        // Keep the first [data-oselected-value] value from parent .sp-product-form-container
        var keptValue = null;
        if (currentFormContainer) {
            var firstOSelected = currentFormContainer.querySelector('[data-oselected-value]');
            if (firstOSelected) {
                keptValue = firstOSelected.getAttribute('data-oselected-value');
            }
        }

        // Get the href link from the clicked .jsp-gitem
        var href = clicked.getAttribute('href');
        if (href) {
            fetch(href)
                .then(function(response) {
                    return response.text();
                })
                .then(function(html) {
                    // Create a temporary DOM to parse the fetched HTML
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    // Find the .sp-product-form-container in the fetched HTML
                    var newFormContainer = tempDiv.querySelector('.jspc-add-wrap');
                    if (newFormContainer) {
                        // Replace the content inside the current container with the new one
                        if (currentFormContainer) {
                            currentFormContainer.innerHTML = newFormContainer.innerHTML;

                            // After load, check for first [data-oselected-value] and child [data-o-value] with kept value, and trigger click
                            if (keptValue !== null) {
                                var firstOSelectedNew = currentFormContainer.querySelector('[data-oselected-value]');
                                if (firstOSelectedNew) {
                                    var matchingChild = firstOSelectedNew.querySelector('[data-o-value][data-o-value="' + keptValue + '"]');
                                    if (matchingChild) {
                                        matchingChild.click();
                                    }
                                }
                            }
                        }
                    }

                })
                .catch(function(error) {
                    // Optionally handle errors
                    console.error('Error fetching product form:', error);
                });
        }
    }


// Use Element type for closest and forEach compatibility
if (target && target.closest && target.closest('.v-thumb')) {
    e.preventDefault();
    var clickedThumb = target.closest('.v-thumb');
    if (clickedThumb) {
        // Remove 'active' from all siblings and add to clicked
        var thumbSiblings = clickedThumb.parentElement ? clickedThumb.parentElement.querySelectorAll('.v-thumb') : [];
        thumbSiblings.forEach(function(sibling) {
            sibling.classList.remove('active');
        });
        clickedThumb.classList.add('active');

        // Find parent .jspc-add-wrap > .jspc-add-style and set data-directadd
        var jspcAddWrap = clickedThumb.closest('.jspc-add-wrap');
        if (jspcAddWrap) {
            var jspcAddStyle = jspcAddWrap.querySelector('.jspc-add-style');
            if (jspcAddStyle) {
                var variantId = clickedThumb.getAttribute('data-variant-id');
                if (variantId !== null) {
                    jspcAddStyle.setAttribute('data-directadd', variantId);
                }
            }
            var activeTier = jspcAddWrap.querySelector('.jsp-add[data-jsp-count].active');
            var tierDisc = activeTier && activeTier.getAttribute('data-tier-discount') != null
                ? activeTier.getAttribute('data-tier-discount')
                : '0';
            fsUpdateJspcCardPricesForBunDiscount(jspcAddWrap, null);
        }

        // Get index of the clicked .v-thumb among its siblings
        var vThumbs = Array.prototype.slice.call(clickedThumb.parentElement ? clickedThumb.parentElement.querySelectorAll('.v-thumb') : []);
        var thumbIndex = vThumbs.indexOf(clickedThumb);
        // Get parent .js-card and locate child with [data-shows] attribute to update it
        var jsCard = clickedThumb.closest('.js-card');
        if (jsCard) {
            var dataShowsEl = jsCard.querySelector('[data-shows]');
            dataShowsEl.setAttribute('data-shows', thumbIndex);
        }

        // Get data-car-image and update parent .js-card > img.first-image src and remove srcset
        var carImage = clickedThumb.getAttribute('data-car-image');
        if (carImage) {
            var jsCard = clickedThumb.closest('.js-card');
            if (jsCard) {
                var firstImage = jsCard.querySelector('img.first-image');
                if (firstImage) {
                    firstImage.setAttribute('src', carImage);
                    firstImage.removeAttribute('srcset');
                // If the parent Flickity slider exists, scroll to the first image
                var parentSlider = firstImage.closest('.flickity-enabled');
                if (parentSlider && parentSlider.flickityInstance) {
                    parentSlider.flickityInstance.select(0);
                } else if (parentSlider && typeof Flickity !== 'undefined') {
                    // If Flickity instance is not attached, try to get it via Flickity.data
                    var flkty = Flickity.data(parentSlider);
                    if (flkty) {
                        flkty.select(0);
                    }
                }
                }
            }
        }
    }
}


});


function initJspcImgSliders() {
    // Select all elements with the class 'jspcimg-slider'
    var sliders = document.querySelectorAll('.jspcimg-slider');
    sliders.forEach(function(slider) {
        // Check if Flickity is available and slider not already initialized
        if (typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
            // Initialize Flickity slider
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                imagesLoaded: true,
                wrapAround: true
            });
            // Remove the class to prevent re-initialization
            slider.classList.remove('jspcimg-slider');
        }
    });
}

// Call the function on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJspcImgSliders);
} else {
    initJspcImgSliders();
}

